/**
 * Trust-signal A/B assignment + Meta Pixel events.
 * Cookie: trust_ab = "0" (control, hide strip) | "1" (variant, show strip)
 * QA: ?trust_v=0|1 overrides and refreshes the cookie.
 */
(function () {
  'use strict';

  var COOKIE = 'trust_ab';
  var DAYS = 30;
  var VIEW_EVENT = 'TrustAB_View';
  var ATC_EVENT = 'TrustAB_AddToCart';
  var PURCHASE_EVENT = 'TrustAB_Purchase';

  function readCookie(name) {
    var parts = ('; ' + document.cookie).split('; ' + name + '=');
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }

  function writeCookie(name, value, days) {
    var maxAge = days * 24 * 60 * 60;
    var secure = location.protocol === 'https:' ? '; Secure' : '';
    document.cookie =
      name +
      '=' +
      value +
      '; Path=/; Max-Age=' +
      maxAge +
      '; SameSite=Lax' +
      secure;
  }

  function qaOverride() {
    try {
      var params = new URLSearchParams(window.location.search);
      var v = params.get('trust_v');
      if (v === '0' || v === '1') {
        writeCookie(COOKIE, v, DAYS);
        return v;
      }
    } catch (e) {}
    return null;
  }

  function assignArm() {
    var qa = qaOverride();
    if (qa) return qa;
    var existing = readCookie(COOKIE);
    if (existing === '0' || existing === '1') return existing;
    var arm = Math.random() < 0.5 ? '0' : '1';
    writeCookie(COOKIE, arm, DAYS);
    return arm;
  }

  function trackCustom(eventName, payload) {
    try {
      if (typeof window.fbq === 'function') {
        window.fbq('trackCustom', eventName, payload || {});
        return;
      }
    } catch (e) {}
    window._trustAbQueue = window._trustAbQueue || [];
    window._trustAbQueue.push([eventName, payload || {}]);
  }

  function flushQueue() {
    if (typeof window.fbq !== 'function' || !window._trustAbQueue) return;
    var q = window._trustAbQueue.slice();
    window._trustAbQueue = [];
    q.forEach(function (item) {
      try {
        window.fbq('trackCustom', item[0], item[1]);
      } catch (e) {}
    });
  }

  function patchFbqForPurchase(arm) {
    if (window._trustAbFbqPatched) return;
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (typeof window.fbq !== 'function') {
        if (tries > 40) clearInterval(timer);
        return;
      }
      clearInterval(timer);
      flushQueue();
      if (window._trustAbFbqPatched) return;
      window._trustAbFbqPatched = true;
      var original = window.fbq;
      window.fbq = function () {
        var args = Array.prototype.slice.call(arguments);
        try {
          original.apply(this, args);
        } catch (e) {}
        try {
          var method = args[0];
          var eventName = args[1];
          if (
            (method === 'track' || method === 'trackCustom') &&
            (eventName === 'Purchase' || eventName === 'purchase')
          ) {
            original.call(this, 'trackCustom', PURCHASE_EVENT, {
              arm: arm,
              experiment: 'trust_signals_v1',
            });
          }
        } catch (e) {}
      };
      // Preserve fbq queue helpers if present
      for (var key in original) {
        if (Object.prototype.hasOwnProperty.call(original, key)) {
          try {
            window.fbq[key] = original[key];
          } catch (e) {}
        }
      }
    }, 250);
  }

  function applyToRoots(arm) {
    var roots = document.querySelectorAll('[data-trust-ab-root]');
    roots.forEach(function (el) {
      el.setAttribute('data-arm', arm);
      if (arm === '1') {
        el.removeAttribute('hidden');
        el.style.removeProperty('display');
      } else {
        el.setAttribute('hidden', '');
        el.style.display = 'none';
      }
    });
    document.documentElement.setAttribute('data-trust-ab', arm);
  }

  function fireViewOnce(arm) {
    var roots = document.querySelectorAll('[data-trust-ab-root]');
    if (!roots.length) return;
    if (window._trustAbViewFired) return;
    window._trustAbViewFired = true;
    trackCustom(VIEW_EVENT, { arm: arm, experiment: 'trust_signals_v1' });
  }

  function bindAddToCart(arm) {
    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!form || !form.getAttribute) return;
        var action = form.getAttribute('action') || '';
        if (action.indexOf('/cart/add') === -1 && !form.matches('form[action*="/cart/add"]')) {
          return;
        }
        trackCustom(ATC_EVENT, { arm: arm, experiment: 'trust_signals_v1' });
      },
      true
    );
  }

  function maybePurchasePage(arm) {
    var path = window.location.pathname || '';
    if (!/thank[_-]?you|checkouts\/.+\/thank|orders\//i.test(path)) return;
    if (sessionStorage.getItem('trust_ab_purchase_sent') === '1') return;
    sessionStorage.setItem('trust_ab_purchase_sent', '1');
    trackCustom(PURCHASE_EVENT, { arm: arm, experiment: 'trust_signals_v1' });
  }

  var arm = assignArm();
  applyToRoots(arm);
  fireViewOnce(arm);
  bindAddToCart(arm);
  patchFbqForPurchase(arm);
  maybePurchasePage(arm);

  // Re-apply after Shopify section morphs / quick view
  document.addEventListener('shopify:section:load', function () {
    applyToRoots(arm);
    fireViewOnce(arm);
  });

  window.TrustAB = {
    arm: arm,
    assignArm: assignArm,
    trackCustom: trackCustom,
  };
})();
